export default __webpack_public_path__ + "static/media/PoweredBy.d54f764b.png";